import { HttpService, Query, QueryHandler, TaggedUrl, Tags, transformDTODate } from '@skylab-shared/core';
import { Transform } from 'class-transformer';
import { PagedCollectionQueryResultDTO } from '../../common/query/paged-collection-query';

export type SaleJpkVatGroupCollectionItem = SaleJpkVatGroupCollectionItemDTO;
class SaleJpkVatGroupCollectionItemDTO {
    public readonly code!: string;
    public readonly description!: string;
    @Transform(transformDTODate, { toClassOnly: true }) public readonly activeFrom?: Date;
    @Transform(transformDTODate, { toClassOnly: true }) public readonly activeTo?: Date;
    public readonly orderBy?: number;
}

export class SaleJpkVatGroupCollectionQuery extends Query<SaleJpkVatGroupCollectionItem[]> { }

export class SaleJpkVatGroupCollectionQueryHandlerBase implements QueryHandler<SaleJpkVatGroupCollectionQuery, SaleJpkVatGroupCollectionItem[]> {
    private static Url = TaggedUrl.join('sales/jpkVatGroups', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: SaleJpkVatGroupCollectionQuery): Promise<SaleJpkVatGroupCollectionItem[]> {
        const { data } = await this.http.get(SaleJpkVatGroupCollectionQueryHandlerBase.Url, {
            dtoObject: new PagedCollectionQueryResultDTO<SaleJpkVatGroupCollectionItemDTO>(SaleJpkVatGroupCollectionItemDTO)
        });
        return data.items.sort((a: SaleJpkVatGroupCollectionItemDTO, b: SaleJpkVatGroupCollectionItemDTO) => {
            const aOrder = a.orderBy ?? 0;
            const bOrder = b.orderBy ?? 0;
            return aOrder === bOrder ? 0 : aOrder < bOrder ? -1 : 1;
        }).map((item: SaleJpkVatGroupCollectionItemDTO) => ({
            code: item.code,
            description: item.description,
            activeFrom: item.activeFrom,
            activeTo: item.activeTo,
            orderBy: item.orderBy
        }));
    }
}
